import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'student',
        loadChildren: () => import('./student/student.module').then((m) => m.StudentModule)
      },
      {
        path: 'register-turnstile',
        loadChildren: () => import('./turnstile/turnstile.module').then((m) => m.TurnstileModule)
      },
      {
        path: 'registration-entries',
        loadChildren: () => import('./registration-entries/registration-entries.module').then((m) => m.RegistrationEntriesModule)
      },
      {
        path: 'equipment',
        loadChildren: () => import('./equipment/equipment.module').then((m) => m.EquipmentModule)
      },
      {
        path: 'exercises',
        loadChildren: () => import('./exercises/exercises.module').then((m) => m.ExercisesModule)
      },
      {
        path: 'workouts',
        loadChildren: () => import('./workouts/workouts.module').then((m) => m.WorkoutsModule)
      },
      {
        path: 'assessments',
        loadChildren: () => import('./assessments/assessments.module').then((m) => m.AssessmentsModule)
      },
      {
        path: 'units',
        loadChildren: () => import('./units/units.module').then((m) => m.UnitsModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EssentialRoutingModule {}
